import { styled } from '../../../theme/stitches.config';
import type * as Stitches from '@stitches/react';

export const SMPRulesColorCircle = styled('span', {
  height: '12px',
  width: '12px',
  borderRadius: '$round',
  display: 'inline-block',
  marginRight: '4px',
  variants: {
    rule: {
      top: {
        background: '$top',
      },
      topplayoff: {
        background: '$topPlayoff',
      },
      relegation: {
        background: '$relegationColor',
      },
      relegationplayoff: {
        background: '$relegationPlayoff',
      },
      promotion: {
        background: '$promotion',
      },
      promotionplayoff: {
        background: '$promotionPlayoff',
      },
      championshipplayoff: {
        background: '$championshipPlayoff',
      },
      tiertwo: {
        background: '$tierTwo',
      },
      tiertwoplayoff: {
        background: '$tierTwoPlayoff',
      },
      none: {
        background: 'inherit',
      },
    },
  },
});

export type StyledSMPRulesColorCircleVariants = Stitches.VariantProps<typeof SMPRulesColorCircle>;
